module.exports = __webpack_public_path__ + "img/modelo_small13.36b7b788.png";